var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21643 10.2723L16.0525 5.51979L23.9822 9.93102M8.21643 10.2723L0.379308 15.0271M8.21643 10.2723L11.6737 12.1834M23.9822 9.93102L31.9103 14.3443M23.9822 9.93102L20.2803 11.9804M8.30906 19.4383L0.379308 15.0271M8.30906 19.4383L8.3465 21.5121M8.30906 19.4383L10.8047 17.8079M0.379308 15.0271L0.41793 17.0987L8.3465 21.5121M8.3465 21.5121L12.6472 18.8264M24.0742 19.0968L31.9103 14.3443M24.0742 19.0968L24.1126 21.1709M24.0742 19.0968L21.6214 17.7409M31.9103 14.3443L31.9494 16.4161L24.1126 21.1709M24.1126 21.1709L19.8093 18.7615M16.1579 18.6847L8.22936 14.2713M16.1579 18.6847L23.9952 13.93M16.1579 18.6847L16.1966 20.7562M8.22936 14.2713L16.0654 9.51881L23.9952 13.93M8.22936 14.2713L8.26683 16.345L16.1966 20.7562M23.9952 13.93L24.0322 16.0036L16.1966 20.7562",
    stroke: "currentColor",
    strokeWidth: 0.484211,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
};

export default __webpack_public_path__ + "static/media/application_flooring.4fb15b10.svg";
export { SvgComponent as ReactComponent };